import { useEffect } from 'react';
import { useLocation } from 'wouter';

/**
 * ScrollToTop component that will scroll the window to the top when the route changes
 */
export default function ScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
} 